<template>
  <div class="home">
    <img src="https://static.rhkj.com/renhe_fe/other/308.png">
  </div>
</template>

<script setup>

</script>



<style scoped lang="scss">
.home {
  padding: 20px 0;
}
</style>
